module.exports = __webpack_public_path__ + "static/media/pl.e22f07b1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flags-select/flags/pl.svg
// module id = 1570
// module chunks = 0